import type { FormValues } from "@/widgets/classic-form/form";

interface BuildResetFormValuesOptions {
    preserveName: boolean;
}

export const buildResetFormValues = (
    initialValues: FormValues,
    currentValues: FormValues,
    { preserveName }: BuildResetFormValuesOptions,
): FormValues => ({
    ...initialValues,
    name: preserveName
        ? {
              ...initialValues.name,
              givenName: currentValues.name.givenName,
              surname: currentValues.name.surname,
              secondSurname: currentValues.name.secondSurname,
          }
        : initialValues.name,
});
